import axios from 'axios';
import '../config.js';

const authConfig = () => ({
  headers: {
    Authorization: `Bearer ${localStorage.getItem('token')}`,
  },
});

const base = (path) => `${global.config.url}/support/activeaccess${path}`;

const normalizeBrandingSignIn = (branding) => {
  const useEmailAddressForSignIn = typeof branding.useEmailAddressForSignIn === 'boolean'
    ? branding.useEmailAddressForSignIn
    : branding.memberNumberType === 'Email';
  const showChildrenAccessButton = Boolean(branding.showChildrenAccessButton);

  return {
    ...branding,
    useEmailAddressForSignIn,
    memberNumberType: useEmailAddressForSignIn ? 'Email' : 'MemberNumber',
    allowMemberNumberEditAfterEmailLookup: useEmailAddressForSignIn && Boolean(branding.allowMemberNumberEditAfterEmailLookup),
    formSurfaceColor: branding.formInputBackgroundColor || branding.formSurfaceColor,
    buttonBorderColor: branding.buttonBackgroundColor || branding.buttonBorderColor,
    scannerActivityColor: branding.buttonBackgroundColor || branding.scannerActivityColor,
    autoPopulateChildrenFromLms: showChildrenAccessButton && Boolean(branding.autoPopulateChildrenFromLms),
  };
};

const activeAccessApi = {
  getActiveAccessCustomers: async () => (await axios.get(base('/customers'), authConfig())).data,
  getActiveAccessCustomer: async (customerId) => (await axios.get(base(`/customers/${customerId}`), authConfig())).data,
  getActiveAccessPortalSummary: async (customerId) => (await axios.get(base(`/customers/${customerId}/portal-summary`), authConfig())).data,
  getChildrenAccessLocations: async (customerId) => (await axios.get(base(`/customers/${customerId}/children-access-locations`), authConfig())).data,
  updateChildrenAccessLocations: async (customerId, request) => (await axios.put(base(`/customers/${customerId}/children-access-locations`), request, authConfig())).data,
  updateActiveAccessPortalAccess: async (customerId, request) => (await axios.put(base(`/customers/${customerId}/portal-access`), request, authConfig())).data,
  createActiveAccessBrandingUploadUrl: async (customerId, request) => (await axios.post(base(`/customers/${customerId}/upload-url`), request, authConfig())).data,
  updateActiveAccessBranding: async (customerId, branding) => (await axios.put(base(`/customers/${customerId}/branding`), normalizeBrandingSignIn(branding), authConfig())).data,
  upsertActiveAccessPortalUser: async (customerId, request) => (await axios.post(base(`/customers/${customerId}/portal-users`), request, authConfig())).data,
  deleteActiveAccessPortalUser: async (customerId, id) => axios.delete(base(`/customers/${customerId}/portal-users/${id}`), authConfig()),
};

export default activeAccessApi;